import React, { useState } from "react";
import { Table, Form, Button,  } from "react-bootstrap";
import RichTextEditor from './RichTextEditor'
import escapeHtml from 'escape-html'
import { Text } from 'slate'

export default function WriteMail(props) {
  const emails = [
    "support@digitalposition.com",
    "datapulse@digitalposition.com"
  ]

  const handleSubmit = (e) => {
    e.preventDefault()
    $.ajax({
			type: "POST",
			url: "/datapulse/admin/send-email",
			data: {
				emailBody: emailBody.map((node) => serialize(node)).join(''),
				emailFrom: emailFrom,
        emailTo: emailTo.split(",").map(email => email.trim()),
        subject: subject
			},
		});
    location.reload()
  }

  const [emailBody, setEmailBody] = useState([])
  const [emailFrom, setEmailFrom] = useState("support@digitalposition.com")
  const [emailTo, setEmailTo] = useState("")
  const [subject, setSubject] = useState("")

  const serialize = node => {
    if (Text.isText(node)) {
      let string = escapeHtml(node.text)
      if (node.bold) {
        string = `<strong>${string}</strong>`
      }
      if (node.italic) {
        string = `<em>${string}</em>`
      }
      if (node.underline) {
        string = `<u>${string}</u>`
      }
      if (node.code) {
        string = `<code>${string}</code>`
      }
      return string
    }
  
    const children = node.children.map(n => serialize(n)).join('')
  
    switch (node.type) {
      case 'heading-one':
        return `<h1>${children}</h1>`
      case 'heading-two':
        return `<h2>${children}</h2>`
      case 'numbered-list':
        return `<ol>${children}</ol>`
      case 'bulleted-list':
        return `<ul>${children}</ul>`
      case 'list-item':
        return `<li>${children}</li>`
      case 'quote':
        return `<blockquote><p>${children}</p></blockquote>`
      case 'paragraph':
        return `<p>${children}</p>`
      case 'link':
        return `<a href="${escapeHtml(node.url)}">${children}</a>`
      default:
        return children
    }
  }

  return(
    <>
      <Form>
        <h1>Send E-Mail from DataPulse</h1>
        <div className="d-flex justify-content-between">
          <div style={{width: "48%"}}>
            <Form.Label>From:</Form.Label>
            <Form.Control
              className="primary mb-2"
              size="md"
              as="select"
              onChange={(e) => setEmailFrom(e.target.value)}
              style={{}}>
              {emails.map((email, index) => {
                return (
                  <option key={index} value={email}>
                    {email}
                  </option>
                );
              })}
            </Form.Control>
          </div>
          <div style={{width: "48%"}}>
            <Form.Label>To:</Form.Label>
            <Form.Control
              className="primary mb-2"
              size="md"
              placeholder="Separate list with commas"
              onChange={(e) => setEmailTo(e.target.value)}
              value={emailTo}
              style={{}}/>
          </div>
        </div>

        <Form.Label>Subject:</Form.Label>
        <Form.Control
          className="primary mb-2"
          size="md mb-4"
          placeholder=""
          onChange={(e) => setSubject(e.target.value)}
          value={subject}
          style={{}}/>

        <RichTextEditor setEmailBody={setEmailBody} />

        <div className="text-right w-100">
          <Button type="submit" variant="secondary" style={{ width: "200px" }} onClick={(e) => handleSubmit(e)}>Send</Button>
        </div>
      </Form>
    </>
  )
}